var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThumbUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 16,
  fill: "none",
  viewBox: "0 0 18 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1C1B1F",
  d: "M14 16H4.5V6l6-6 .667.458q.354.25.541.636.188.385.104.802l-.02.104L11 6h5.5q.625 0 1.063.438Q18 6.874 18 7.5v1.188a1.35 1.35 0 0 1-.125.583l-2.48 5.817a1.54 1.54 0 0 1-.562.662A1.47 1.47 0 0 1 14 16m-8-1.5h8l2.5-5.812V7.5H9.167l1.02-5.062L6 6.625zM4.5 6v1.5h-3v7h3V16H0V6z"
})));
export default SvgThumbUp;